var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67955 8.61315C8.72433 8.64358 8.77244 8.66621 8.80833 8.70183C9.83009 9.72222 10.85 10.7445 11.8725 11.7637C12.0076 11.8984 12.0801 12.0487 12.0335 12.2372C11.9546 12.5556 11.5664 12.6773 11.3148 12.4661C11.2759 12.4335 11.2412 12.396 11.2049 12.36C10.1939 11.3485 9.18284 10.3371 8.17182 9.32557C8.13925 9.29329 8.10557 9.26212 8.06598 9.2239C6.77333 10.2395 5.32526 10.5905 3.72842 10.1946C2.53236 9.8981 1.58573 9.21425 0.890377 8.19609C-0.499595 6.16089 -0.136189 3.40399 1.72932 1.77248C3.5815 0.152846 6.36552 0.175851 8.1955 1.81367C10.0566 3.47931 10.4533 6.42544 8.67955 8.61315ZM4.93743 1.45894C2.73997 1.45931 0.936635 3.26595 0.939966 5.46331C0.943296 7.6577 2.73701 9.45358 4.93188 9.45989C7.12675 9.4662 8.93416 7.66178 8.93675 5.4622C8.93897 3.26373 7.13563 1.4582 4.93743 1.45894Z",
    fill: "black",
    fillOpacity: 1,
    stroke: "black",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b06e50353a563e1ea65d8603a131594e.svg";
export { ForwardRef as ReactComponent };